<template>
  <BaseDialogForm
    v-model="showChangePasswordForm"
    title="Change Password"
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #actions>
      <v-btn
        color="primary"
        depressed
        @click="submitForm()"
        :disabled="!isValid"
      >
        Submit
      </v-btn>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="changePasswordForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col cols="12" class="d-flex align-center">
            <v-alert
              text
              border="left"
              elevation="0"
              dense
              width="100%"
              type="info"
              class="ma-0"
            >
              Note : You'll be logged out after changing the password!
            </v-alert>
          </v-col>
          <v-col cols="4" lg="4">
            <PasswordField
              id="old_password"
              name="old_password"
              label="Old Password"
              v-model="changePasswordForm.old_password"
              required
              :error-messages="formErrors.old_password"
              @input="delete formErrors.old_password"
            />
          </v-col>
          <v-col cols="4" lg="4">
            <PasswordField
              id="new_password"
              name="new_password"
              label="New Password"
              v-model="changePasswordForm.new_password"
              required
              :error-messages="formErrors.new_password"
              :rules="
                changePasswordForm.new_password != null &&
                confirmPassword != null
                  ? passwordValidation
                  : []
              "
              @input="delete formErrors.new_password"
            />
          </v-col>
          <v-col cols="4" lg="4">
            <PasswordField
              id="confirmPassword"
              name="confirmPassword"
              label="Confirm password"
              v-model="confirmPassword"
              required
              :rules="
                changePasswordForm.new_password != null &&
                confirmPassword != null
                  ? passwordValidation
                  : []
              "
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseDialogForm>
</template>

<script>
import { bus } from "@/main.js";
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";

export default {
  emits: ["logout"],
  components: {
    BaseDialogForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewPassword: false,
      newPassword: false,
      oldPassword: false,

      formCount: 0,
      isValid: true,
      changePasswordForm: {},

      formErrors: {},
      confirmPassword: null,
    };
  },
  computed: {
    showChangePasswordForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    passwordValidation() {
      return [
        this.changePasswordForm.new_password == this.confirmPassword ||
          `Password does not match`,
      ];
    },
  },
  watch: {
    value(val) {
      if (!val) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.changePasswordForm = {};
      this.confirmPassword = "";
      this.$refs.changePasswordForm.resetValidation();
    },
    submitForm() {
      if (!this.$refs.changePasswordForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      bus.$emit("showLoader", true);
      this.$api.profile
        .changePassword(this.changePasswordForm)
        .then(() => {
          this.showChangePasswordForm = false;
          bus.$emit("showToastMessage", {
            message: "Password changed successfully!",
            color: "success",
          });
          setTimeout(() => {
            bus.$emit("showLoader", false);
            this.$emit("logout");
          }, 3000);
        })
        .catch((err) => {
          this.formErrors = err.data;
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "Couldn't change Password!",
            color: "error",
          });
        });
    },
  },
  mounted() {},
};
</script>

<style></style>
